import { render, staticRenderFns } from "./registerPeople.vue?vue&type=template&id=0bab7df0&scoped=true&"
import script from "./registerPeople.vue?vue&type=script&lang=js&"
export * from "./registerPeople.vue?vue&type=script&lang=js&"
import style0 from "./registerPeople.vue?vue&type=style&index=0&id=0bab7df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bab7df0",
  null
  
)

export default component.exports